import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <div className="img">
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1726123405775/2_pc.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1726123416916/2_m.jpg"
                />
            </div>
        </div>
    );
}
